import React from "react";
import TextInput from "../../Components/Inputs/TextInput";
import ReactSelectInput from "../../Components/Inputs/ReactSelectInput";

const activeOptions = [
  {id: 1, name: 'Active'},
  {id: 0, name: 'Inactive'},
];

export default function ({register, errors, control}) {
  return (
    <>
      <TextInput
        label="First name"
        name="first_name"
        register={register}
        errorMessage={errors?.first_name}
        required={true}
      />

      <TextInput
        label="Last name"
        name="last_name"
        register={register}
        errorMessage={errors?.last_name}
        required={true}
      />

      <TextInput
        label="E-Mail"
        name="email"
        register={register}
        required={true}
        errorMessage={errors?.email}
      />

      <TextInput
        label="Phone"
        name="phone"
        register={register}
        required={true}
        type="tel"
        errorMessage={errors?.phone}
      />

      <ReactSelectInput
        label="Status"
        name="is_active"
        control={control}
        errorMessage={errors?.is_active}
        options={activeOptions}
      />
    </>
  );
}